enum UserCommunicationRedirectRoutes {
  PAYCHECK_NOTIFICATION = 'MY_PAYCHECKS',
  RHT_INVOICE_REQUEST = 'MY_INVOICES',
}

export { UserCommunicationRedirectRoutes };
